module.exports = __webpack_public_path__ + "static/JasmineNauta-291dba57b40cbf280fad0211fede2fdb.jpg";